import { gql } from '@apollo/client';

export interface CreateAndAssociateInvoiceDetailsResponse {
  uuid: string;
  name: string;
  address_line1: string;
  address_line2?: string;
  address_city: string;
  address_postcode: string;
  created: string;
  updated: string;
}

export interface CreateAndAssociateInvoiceDetailsDataVariable {
  invoiceDetailId?: string;
  name: string;
  addressLine1: string;
  addressLine2?: string;
  addressCity: string;
  addressPostcode: string;
}

export interface CreateAndAssociateInvoiceDetailsVariables {
  quoteId: string;
  data: CreateAndAssociateInvoiceDetailsDataVariable;
}

export const CREATE_AND_ASSOCIATE_INVOICE_DETAILS = gql`
  mutation createAndAssociateInvoiceDetails(
    $quoteId: String!,
    $data: InvoiceDetailsInput!
  ) {
    createAndAssociateInvoiceDetails(
      quoteId: $quoteId,
      data: $data
    ) {
      uuid,
      name,
      address_line1,
      address_line2,
      address_city,
      address_postcode,
      created,
      updated
    }
  }
`;
